var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { catchError } from '@cabloy/utils';
import { cast } from 'zova';
import { BeanInterceptorBase, Interceptor } from 'zova-module-a-fetch';
export let InterceptorPerformAction = (_dec = Interceptor({
  dependencies: 'a-interceptor:jwt'
}), _dec2 = __z_BeanInfo({
  module: "a-interceptor"
}), _dec(_class = _dec2(_class = class InterceptorPerformAction extends BeanInterceptorBase {
  async onRequest(config, _options, next) {
    if (process.env.CLIENT) return next();
    const performAction = this.ctx.meta.$ssr.getPerformAction(config.baseURL);
    if (!performAction) return next();
    const data = {
      method: config.method,
      path: config.url,
      query: config.params,
      body: config.data,
      headers: config.headers
    };
    const [result, error] = await catchError(() => {
      return performAction(data);
    });
    if (error) {
      cast(error).config = config;
      throw error;
    }
    throw result;
  }
}) || _class) || _class);